// Auto-generated enum from table Functions

export const systemFunction = {
    administrator: 'administrator',
    billingAdministrator: 'billingAdministrator',
    domainAdministrator: 'domainAdministrator',
    domainPartner: 'domainPartner',
    domainUser: 'domainUser',
    entityOwner: 'entityOwner',
    owner: 'owner',
    projectManager: 'projectManager',
    projectMember: 'projectMember',
    recordOwner: 'recordOwner',
    superAdministrator: 'superAdministrator',
    taskManager: 'taskManager',
    taskMember: 'taskMember',
    user: 'user',
}

export type TSystemFunction = (typeof systemFunction)[keyof typeof systemFunction];

